module.exports = "<tabset (click)=\"tabClick($event)\">\n  <tab heading=\"Inactivar funcionarios\" id=\"tabInactivar\">\n    <div class=\"col-12 mt-2\">\n      <iw-inactivate-users></iw-inactivate-users>\n    </div>\n  </tab>\n  <tab heading=\"Historial de funcionarios inactivos\" id=\"tabHistorial\">\n    <div class=\"col-12 mt-2\">\n      <iw-history-users-inactivation></iw-history-users-inactivation>\n    </div>\n  </tab>\n</tabset>\n  \n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/system-users-inactivation/system-users-inactivation.component.html
// module id = ./src/app/administration/system-users-inactivation/system-users-inactivation.component.html
// module chunks = main